// /admin/admins + /admin/me 服务封装。
// 端点契约:apps/gateway/src/routes/admin/admin-users.ts;响应 schema 与 Gateway 共用 @novelaide/shared-types。
import { adminApi } from '../client'
import { OkResponseSchema } from '../_schemas'
import {
  AdminAccountResponseSchema,
  AdminAccountsResponseSchema,
  AdminMeResponseSchema,
  type AdminAccountResponse,
  type AdminAccountsResponse,
  type AdminMeResponse,
  type AdminUser
} from '@novelaide/shared-types/admin-auth'

export type { AdminMeResponse, AdminUser }

export const adminsApi = {
  bootstrap: (input: {
    rootToken: string
    username: string
    password: string
    displayName?: string | null
  }) =>
    adminApi.post<AdminAccountResponse>('/admin/bootstrap', input, AdminAccountResponseSchema, {
      skipAuth: true,
      fallbackErrorCode: 'admin_bootstrap_failed'
    }),

  /** 当前调用者（用于限制管理员只修改自己的密码）。 */
  me: () => adminApi.get<AdminMeResponse>('/admin/me', AdminMeResponseSchema),

  list: () => adminApi.get<AdminAccountsResponse>('/admin/admins', AdminAccountsResponseSchema),

  /** 创建管理员。username: 3-32 字符 [a-z0-9]+;password: 8-256 + 必须含大小写+数字+特殊符号 */
  create: (input: { username: string; password: string; displayName?: string | null }) =>
    adminApi.post<AdminAccountResponse>('/admin/admins', input, AdminAccountResponseSchema),

  /** 管理员只能修改自己的密码。 */
  changePassword: (id: string, currentPassword: string, password: string) =>
    adminApi.patch<{ ok: true }>(
      `/admin/admins/${id}/password`,
      { currentPassword, password },
      OkResponseSchema
    ),

  disable: (id: string) =>
    adminApi.post<{ ok: true }>(`/admin/admins/${id}/disable`, undefined, OkResponseSchema),
  enable: (id: string) =>
    adminApi.post<{ ok: true }>(`/admin/admins/${id}/enable`, undefined, OkResponseSchema)
}
